export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUAQMAAAC3R49OAAAAA1BMVEX///+nxBvIAAAAC0lEQVQI12OgMgAAAFAAAYDDu4cAAAAASUVORK5CYII="